/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档

  
    
export interface IAPI77006ReqOrderObjectsItem {
  
  /**  */
  orderByColumn?: string;
  
  /**  */
  orderByDesc?: boolean;
  
};
    
  
    
export interface IAPI77006ResListItemBlockListItemPropertyListItemOptionListItem {
  
  /** 选项名称 */
  key?: string;
  
  /** 选项值 */
  value?: string;
  
};
    
  
    
export interface IAPI77006ResListItemBlockListItemPropertyListItem {
  
  /** 属性名称 */
  propertyName?: string;
  
  /** 属性类型 */
  propertyType?: string;
  
  /** 选项范围 ,OptionResp */
  optionList?: IAPI77006ResListItemBlockListItemPropertyListItemOptionListItem[];
  
};
    
  
    
export interface IAPI77006ResListItemBlockListItem {
  
  /** 区块名称 */
  blockName?: string;
  
  /** 区块类型 */
  blockType?: string;
  
  /** 最少数量 */
  leastNum?: number;
  
  /** 最多数量 */
  mostNum?: number;
  
  /** 属性列表 ,PropertyResp */
  propertyList?: IAPI77006ResListItemBlockListItemPropertyListItem[];
  
};
    
  
    
export interface IAPI77006ResListItem {
  
  /** 组件模板编码 */
  componentCode?: string;
  
  /** 组件模板名称 */
  componentName?: string;
  
  /** 组件分类 */
  componentClassify?: string;
  
  /** 组件状态:0禁用,1启用 */
  componentStatus?: number;
  
  /** 组件类型 */
  componentType?: string;
  
  /** 区块列表 ,BlockResp */
  blockList?: IAPI77006ResListItemBlockListItem[];
  
};
    
  



export interface API77006Req {
  
  /** 组件名称 */
  componentName?: string;
  /**  */
  pageSize?: number;
  /**  */
  pageIndex?: number;
  /**  */
  rowId?: string;
  /**  */
  jumpType?: number;
  /**  */
  searchCount?: boolean;
  /** OrderByColumn */
  orderObjects?: IAPI77006ReqOrderObjectsItem[];
};



export interface API77006Res {
  /** T  */
  list?: IAPI77006ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 77006 获取组件模板列表

export interface IUsePostAPI77006Return {
  /** 获取组件模板列表: 接口请求状态 */
  isAPI77006Loading: boolean;
  /** 获取组件模板列表: 接口请求返回数据 */
  dataAPI77006: API77006Res;
  /**  获取组件模板列表: 接口数据请求方法 */
  fetchAPI77006Data: (inputs: API77006Req, config?: YWRequestConfig) => Promise<API77006Res>;
  /** 获取组件模板列表: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77006 = ():IUsePostAPI77006Return => {
  let isMount = true;
  const [isAPI77006Loading, setIsAPI77006Loading] = useState(false);
  const [dataAPI77006, setDataAPI77006] = useState<API77006Res>({} as API77006Res);
  const requestUrl = `${basePath}/yoaichat-admin/component/template/page`;

  const fetchAPI77006Data = async (inputs: API77006Req, config?: YWRequestConfig): Promise<API77006Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77006Req>) || {}) as API77006Req;
    
  
    if ( isMount ) {
      setIsAPI77006Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77006Res>(`${basePath}/yoaichat-admin/component/template/page`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77006(res || {} as API77006Res);
        setIsAPI77006Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77006Loading(false);
      }
      return false as unknown as API77006Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77006Loading,
    dataAPI77006,
    fetchAPI77006Data,
    requestUrl,
  }
}

